import React from "react";
import { CheckIcon, GlobeIcon, ShieldCheckIcon, DownloadIcon, InfinityIcon, BanIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { offerItems, images } from "../../data/content";
const perks = [{
  icon: CheckIcon,
  label: "One-Time Payment"
}, {
  icon: BanIcon,
  label: "No Monthly Fees"
}, {
  icon: InfinityIcon,
  label: "Lifetime Access"
}, {
  icon: DownloadIcon,
  label: "Instant Download"
}];
export function Offer() {
  const total = offerItems.reduce((s, i) => s + i.value, 0);
  return <section id="offer" className="bg-ink-950 px-4 py-16 sm:px-5 sm:py-20" data-id="element-200" data-mp="3jwbafltqfk7w">
      <div className="mx-auto max-w-2xl" data-id="element-201" data-mp="3nxd9o2nnfw9v">
        <div className="text-center" data-id="element-202" data-mp="3nwbw9rj5uxoz">
          <p className="inline-block rounded-full bg-alert px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-203" data-mp="3svy9i0yzodxs">Special Launch Offer</p>
          <h2 className="mt-4 font-display text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-204" data-mp="1pwwvnzdlca1">Here's Everything You'll Receive Today</h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border-2 border-brand bg-ink-800" data-id="element-205" data-mp="1fm3wvuoe2xf6">
          <img src={images.main} alt="Occlusion Blueprint complete collection" className="w-full bg-ink-900" data-id="element-206" data-mp="1bk0boebx4egp" />
          <ul className="divide-y divide-white/10 px-5 sm:px-7" data-id="element-207" data-mp="16mqnt346gauz">
            {offerItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-4" data-id="element-208" data-mp="23aobnn1uvdss">
                <span className="flex gap-2.5 text-[15px] font-semibold leading-snug text-white" data-id="element-209" data-mp="1zbfk8ouafs0e">
                  <CheckIcon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-210" data-mp="1uimfi0ytkjob" />
                  {item.label}
                </span>
                <span className="shrink-0 text-sm font-bold text-red-300 line-through" data-id="element-211" data-mp="2n0gv0iqlff8u">${item.value}</span>
              </li>)}
          </ul>

          <div className="bg-ink-900 px-5 py-8 text-center sm:px-7" data-id="element-212" data-mp="2i7xebcwm03zt">
            <p className="text-sm font-bold uppercase tracking-wide text-slate-300" data-id="element-213" data-mp="316il0pp82wj5">
              Total reference value: <span className="text-red-300 line-through" data-id="element-214" data-mp="3638zx9pajm2z">${total}</span>
            </p>
            <p className="mt-4 font-display text-base font-extrabold uppercase text-white" data-id="element-215" data-mp="2sc41gaxnszu8">Today, get everything for just</p>
            <p className="mt-1 font-display text-[88px] font-black leading-none text-cta sm:text-[110px]" data-id="element-216" data-mp="2wcxu1hm1r2tg">
              <span className="align-top text-4xl sm:text-5xl" data-id="element-217" data-mp="2ih2ffnyokdvv">$</span>27
            </p>
            <p className="mt-1 font-display text-lg font-bold text-white" data-id="element-218" data-mp="2nfdovxl2cmdk">USD · One-Time Payment</p>

            <div className="mx-auto mt-5 flex max-w-md items-start gap-3 rounded-2xl bg-brand/15 p-4 text-left ring-1 ring-brand/40" data-id="element-219" data-mp="29g47wvp19o8j">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-220" data-mp="7n7p2movthdv" />
              <p className="text-sm leading-relaxed text-slate-100" data-id="element-221" data-mp="bojgmxrbgcop">
                <strong className="text-white" data-id="element-222" data-mp="bnqiumac4xip">Automatic currency conversion:</strong> the price is converted to your local currency according to your country at checkout.
              </p>
            </div>

            <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-2" data-id="element-223" data-mp="1s2w1ghvb8vye">
              {perks.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-left text-xs font-semibold text-slate-200 sm:text-sm" data-id="element-224" data-mp="215x5md0m8czf">
                  <Icon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-225" data-mp="2fsqeazfmqkin" />
                  {label}
                </li>)}
            </ul>

            <div className="mt-7 space-y-6" data-id="element-226" data-mp="2ovho6usux886">
              <CtaButton label="Get Occlusion Blueprint Now" microcopy="Instant Digital Access · One-Time Payment of $27 · 7-Day Guarantee" data-id="element-227" data-mp="2ot5a4sq7zi0e" />
              <Countdown data-id="element-228" data-mp="ugozzguazjq9" />
              <ScarcityBar data-id="element-229" data-mp="ui0118wd6ddo" />
            </div>

            <p className="mt-6 flex items-center justify-center gap-2 text-xs text-slate-400" data-id="element-230" data-mp="pi5ax7kexrto">
              <ShieldCheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-231" data-mp="rwslmvmtnyev" /> Secure checkout · 7-day satisfaction guarantee
            </p>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-[15px] leading-relaxed text-slate-300" data-id="element-232" data-mp="vwkn6odst4aq">
          For $27, you'll receive a complete collection of organized educational and clinical documentation resources you can revisit whenever you need to review your approach to an occlusal case. Everything is delivered together in one organized collection.
        </p>
      </div>
    </section>;
}